import { useContext } from "react";
import { DeleteModal, ModalContext } from "dash-ui";

import {
  GetCmsUsersDocument,
  useDeleteUserCmsMutation,
} from "gql/generated.graphql";

function DeleteCmsUserModal() {
  const { payload } = useContext(ModalContext);

  const [deleteUser, { loading }] = useDeleteUserCmsMutation({
    refetchQueries: [GetCmsUsersDocument],
  });

  async function submitUserCmsDelete() {
    const { accountId, profileId } = payload;
    await deleteUser({ variables: { accountId, profileId } });
  }

  return (
    <DeleteModal
      entity="User"
      name={payload?.userName}
      isLoading={loading}
      modalName="UserCmsDeleteModal"
      onClick={submitUserCmsDelete}
    />
  );
}

export default DeleteCmsUserModal;
